export default __webpack_public_path__ + "static/media/Green0000.95bc7b24.png";